import { Injectable } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { PopupMessageComponent } from '../components/shared/popup-message/popup-message.component';

@Injectable({ providedIn: 'root' })
export class ModalService {
    bsModalRef: BsModalRef;
    constructor(private bsModalService: BsModalService) {}

    confirm(popupDispalyObj: any, className?: string) {
        const initialState = {
            popupDispalyObj: popupDispalyObj,
        };
        this.bsModalRef = this.bsModalService.show(PopupMessageComponent, { initialState });
        if (className) {
            this.bsModalRef.setClass(className);
        }
        return new Observable<string[]>(this.getConfirmSubscriber());
    }

    private getConfirmSubscriber() {
        return (observer: any) => {
            const subscription = this.bsModalService.onHidden.subscribe((reason: string[]) => {
                observer.next(this.bsModalRef.content.popupCallbackDetail);
                observer.complete();
            });

            return {
                unsubscribe() {
                    subscription.unsubscribe();
                },
            };
        };
    }
}
